import { render, staticRenderFns } from "./GuestDrawer.vue?vue&type=template&id=0bdf8304&scoped=true&"
import script from "./GuestDrawer.vue?vue&type=script&lang=ts&"
export * from "./GuestDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf8304",
  null
  
)

export default component.exports